import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabaseFontSelectionSummaryService } from "../server/font-selection-summary-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type FontSelectionSummary = Database["public"]["Views"]["font_selection_summary"]["Row"];

export function useFontSelections(): ReturnType<typeof useSupabaseLoader<FontSelectionSummary[]>> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseFontSelectionSummaryService(supabase).getAll(
      account_id,
      { order: [{ column: "default_for", dir: "asc" }] },
    );

    if (error) throw error;

    return data;
  }, []);
}
